import { SearcherSelectionItemMapper as defaultItemMapper } from '@/modules/entity/mappers';
import { SearcherSelectionItemMapper as contentItemMapper } from '@/modules/content/mappers';
import { SearcherSelectionItemMapper as taxonomyItemMapper } from '@/modules/taxonomy/mappers';
import { SearcherSelectionItemMapper as boardItemMapper } from '@/modules/board/mappers';
import { typeToIcon as contentTypeToIcon } from '@/modules/content/config';
import { typeToIcon as taxonomyTypeToIcon } from '@/modules/taxonomy/config';
import isObject from 'lodash/isObject';

import ContentImageWizard from '@/modules/content/wizard/WizardImage';
import WizardPhotoGallery from '@/modules/content/wizard/WizardPhotoGallery';
import ContentVideoEmbedWizard from '@/modules/content/wizard/WizardVideoEmbed';
import ContentAudioWizard from '@/modules/content/wizard/WizardAudio';
import ContentVideoWizard from '@/modules/content/wizard/WizardVideo';
import ContentFileWizard from '@/modules/content/wizard/WizardFile';
import ContentWizard from '@/modules/content/wizard/WizardArticle';
import TaxonomyWizard from '@/modules/taxonomy/wizard/Wizard';
import TwitterAccountWizard from '@/modules/social-network/account/wizard/TwitterWizard';
import FacebookAccountWizard from '@/modules/social-network/account/wizard/FacebookWizard';
import LiveWizard from '@/modules/content/wizard/WizardLive';
import WizardMultipleImages from '@/modules/content/wizard/WizardMultipleImages.vue';

const searcherFilterWatchFunctions = {};

export function setSearcherFilterWatchFunction(searcher, callback) {
  if (!searcherFilterWatchFunctions[searcher]) {
    searcherFilterWatchFunctions[searcher] = [];
  }
  searcherFilterWatchFunctions[searcher].push(callback);
}

export function getSearcherFilterWatchFunctions(searcher) {
  return searcherFilterWatchFunctions[searcher] || [];
}

export const LIST_VIEW_NORMAL = {
  text: 'normal',
  icon: 'format_list_bulleted',
  value: 'normal',
};
export const LIST_VIEW_CONDENSED = {
  text: 'condensed',
  icon: 'list',
  value: 'condensed',
};
export const LIST_VIEW_MOSAIC = {
  text: 'mosaic',
  icon: 'apps',
  value: 'mosaic',
};

const defaultSearcherContentTypes = ['article'];
const defaultSearcherContentTypesBySite = {
  // vertele: ['video']
};

export const selectionItemMappers = {
  default: defaultItemMapper,
  content: contentItemMapper,
  category: taxonomyItemMapper,
  board: boardItemMapper,
};

// TODO: import for content and taxonomy module
export const wizards = {
  article: {
    name: 'article',
    icon: contentTypeToIcon('article'),
    component: ContentWizard,
  },
  audio: {
    name: 'audio',
    icon: contentTypeToIcon('audio'),
    component: ContentAudioWizard,
  },
  image: {
    name: 'image',
    icon: contentTypeToIcon('image'),
    component: ContentImageWizard,
  },
  multipleImages: {
    name: 'multipleImages',
    icon: contentTypeToIcon('photogallery'),
    component: WizardMultipleImages,
  },
  photogallery: {
    name: 'photogallery',
    icon: contentTypeToIcon('photogallery'),
    component: WizardPhotoGallery,
  },
  video: {
    name: 'video',
    icon: contentTypeToIcon('video'),
    component: ContentVideoWizard,
  },
  file: {
    name: 'file',
    icon: contentTypeToIcon('file'),
    component: ContentFileWizard,
  },
  microsite: {
    name: 'microsite',
    icon: taxonomyTypeToIcon('microsite'),
    component: TaxonomyWizard,
  },
  blog: {
    name: 'blog',
    icon: taxonomyTypeToIcon('blog'),
    component: TaxonomyWizard,
  },
  tag: {
    name: 'tag',
    icon: taxonomyTypeToIcon('tag'),
    component: TaxonomyWizard,
  },
  author: {
    name: 'author',
    icon: taxonomyTypeToIcon('author'),
    component: TaxonomyWizard,
  },
  videoembed: {
    name: 'videoembed',
    icon: contentTypeToIcon('videoembed'),
    component: ContentVideoEmbedWizard,
  },
  twitterAccount: {
    name: 'twitterAccount',
    icon: 'fa-twitter',
    component: TwitterAccountWizard,
  },
  facebookAccount: {
    name: 'facebookAccount',
    icon: 'fa-facebook',
    component: FacebookAccountWizard,
  },
  live: {
    name: 'live',
    icon: contentTypeToIcon('live'),
    component: LiveWizard,
  },
};

const contentSelectorHintConfig = [
  card => `ID: ${isObject(card) ? card.id : card}`,
];


/**
 * Searches limit configuration.
 *
 * This object allows to configure the searches limit's default behaviour.
 *   - The `available` property defines what options will be available in the limit selector.
 *   - The `default` property defines the default limit.
 *
 * This configuration can be overwritten in API, via the site configuration service, in the following manner:
 *   - `searcherConfig.searchLimitConfig` property, to define the general behaviour for all searchers.
 *   - `searcher.<entity_type>.searchLimitConfig` property, to define the behaviour for the searcher of a single entity.
 *
 * @type {{default: number, options: number[]}}
 */
export const searchLimitConfig = {
  available: [20, 50, 100],
  default: 20,
};

export default {
  selectionItemMappers,
  wizards,
  defaultSearcherContentTypes,
  defaultSearcherContenTypesBySite: defaultSearcherContentTypesBySite,
  contentSelectorHintConfig,
  searchLimitConfig,
};
